import { useInfiniteQuery } from '@tanstack/react-query';
import { fetchCities } from '@/features/location/api/locationApi';
import { queryKeys } from '@/shared/lib/query/queryKeys';

const PAGE_SIZE = 10;

export function useInfiniteCities(search: string, enabled = true) {
  return useInfiniteQuery({
    queryKey: queryKeys.locations.cities(search),
    queryFn: ({ pageParam }) => fetchCities(search, pageParam, PAGE_SIZE),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      lastPage?.data?.length === PAGE_SIZE ? allPages.length + 1 : undefined,
    enabled,
    refetchOnWindowFocus: false,
  });
}
